import { View } from 'backbone.marionette';
import Tooltip from 'app/backbone/lib/concerns/views/tooltip';

export default View.extend({
  behaviors: [Tooltip]
});
